module.exports = __webpack_public_path__ + "static/media/thumb-up-yellow.4022bd82.svg";